import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { BaseViewComponent } from '@sb/library/base';
import { AttachmentBehaviour, IAttachmentDisplayItem } from '@sb/library/data-models';

interface IDescriptionAttachmentDisplayItem extends IAttachmentDisplayItem {
    Description?: string | null;
}

@Component({
    selector: 'lib-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent<T extends IAttachmentDisplayItem>  extends BaseViewComponent implements OnInit {
    @Input() isLoading: boolean = true;
    @Input() attachments: Array<T> = [];
    @Input() hideDownloadButton: boolean = false;
    @Input() hideViewButton: boolean = false;
    @Input() hideShowButton: boolean = false;
    @Input() canDelete: boolean = false;
    @Input() canEdit: boolean = false;

    @Output() editAttachment = new EventEmitter<T>();
    @Output() deleteAttachment = new EventEmitter<T>();

    HasDescription(item: IDescriptionAttachmentDisplayItem): boolean {
        return item && item.Description !== null && item.Description !== undefined;
    }

    GetDescription(item: IDescriptionAttachmentDisplayItem): string {
        return this.HasDescription(item) ? `${item.Description}` : "";
    }

    IsPlayable(item: IAttachmentDisplayItem): boolean {
        return item && item.AttachmentBehaviour && item.AttachmentBehaviour === AttachmentBehaviour.Playable;
    }

    IsImage(item: IAttachmentDisplayItem): boolean {
        return item && item.AttachmentBehaviour && item.AttachmentBehaviour === AttachmentBehaviour.Image;
    }

    IsPDF(item: IAttachmentDisplayItem): boolean {
        return item && item.AttachmentBehaviour && item.AttachmentBehaviour === AttachmentBehaviour.PDF;
    }

    IsNone(item: IAttachmentDisplayItem): boolean {
        return item && item.AttachmentBehaviour && item.AttachmentBehaviour === AttachmentBehaviour.None;
    }

    DeleteAttachment(attachment: T) {
        this.deleteAttachment.emit(attachment);
    }

    DownloadAttachment(attachment: IAttachmentDisplayItem) {
        if (attachment && attachment.DownloadURL) {
            window.open(attachment.DownloadURL, '_self');
        }
    }

    ViewAttachment(attachment: IAttachmentDisplayItem) {
        if (attachment && attachment.ViewURL) {
            window.open(attachment.ViewURL, '_blank');
        }
    }

    EditAttachment(attachment: T) {
        this.editAttachment.emit(attachment);
    }

    IsPanelExpanded(matExpansionPanel: MatExpansionPanel): boolean {
        return matExpansionPanel ? matExpansionPanel.expanded : false;
    }

    ShowShowButton(attachment: IAttachmentDisplayItem): boolean {
        return !this.hideShowButton && this.IsImage(attachment) && attachment.ViewURL != null;
    }
}
